import React, { useMemo } from 'react';
import { Table } from 'antd';
import { useScrollUpPage } from 'shared/hooks';
import { SearchKeysNews } from 'shared/enums/news';
import { TVacationScheduleRequestPrepared } from 'shared/types/vacation-schedule.types';
import { ColumnsType } from 'antd/lib/table';
import { RequestStatusType } from 'shared/enums';
import style from './index.module.scss';

type TProps = {
  dataSource: TVacationScheduleRequestPrepared[];
  columns: ColumnsType<TVacationScheduleRequestPrepared>;
  currentPage: number;
  currentSize: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  setCurrentSize: React.Dispatch<React.SetStateAction<number>>;
  total: number | undefined;
  onSearch?: (data: string, key: SearchKeysNews) => void;
  onRowClick?: (record: TVacationScheduleRequestPrepared[][number]) => void;
};

export const TableUserVsSubs = ({
  dataSource,
  columns,
  currentPage,
  setCurrentPage,
  total,
  setCurrentSize,
  currentSize,
  onSearch,
  onRowClick,
}: TProps) => {
  const handlePagination = (value: number, pageSize: number) => {
    setCurrentSize(pageSize);
    setCurrentPage(value);
  };

  useScrollUpPage(currentPage);

  const filteredColumns = useMemo(() => {
    if (
      dataSource?.[0]?.status.type === RequestStatusType.rejectedBySupervisor ||
      dataSource?.[0]?.status.type === RequestStatusType.rejectedByHR
    ) {
      return columns.filter(elem => elem.key !== 'action');
    }
    return columns;
  }, [dataSource, columns]);

  return (
    <Table
      scroll={{ x: true }}
      dataSource={dataSource}
      columns={filteredColumns}
      pagination={false}
      bordered
      rootClassName={style.row}
      onRow={record => ({
        onClick: () => {
          onRowClick?.(record);
        },
      })}
    />
  );
};
